// extracted by mini-css-extract-plugin
export default {"navContainerDesktop":"Header_navContainerDesktop__PRLa6","active":"Header_active__rHuVo","navContainerMobile":"Header_navContainerMobile__OfKJI"};